<template>
    <v-layout>
        <Header v-on:studyChange="selectStudy"></Header>
        <v-main style="background: rgb(224, 224, 224);">
            <div style="padding: 10px 10px;">
                <v-row no-gutters>
                    <h1>Available Reports</h1>
                </v-row>
                <div class="elevation-2" style="background: white; padding: 10px 10px;">
                    <v-row no-gutters>
                        <v-col cols="12" md="3" lg="2">
                            <div class="reportingTitle" style="font-size: 20px">REPORT NAME</div>
                        </v-col>
                        <v-col cols="12" md="9" lg="10">
                            <div class="reportingTitle" style="font-size: 20px">DESCRIPTION</div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters v-for="test in availableReportNames" :key="test.reportClass"
                        style="text-align: left; margin-top: 10px;">
                        <v-col cols="12" md="3" lg="2" style="font-weight: bold;">{{ test.reportClass }}</v-col>
                        <v-col cols="12" md="9" lg="10">{{ test.reportDescription }}</v-col>
                    </v-row>
                </div>
            </div>
            <div style="padding: 10px 10px; background: rgb(224, 224, 224);">
                <v-row no-gutters>
                    <h1>Run a Report</h1>
                </v-row>
                <v-row no-gutters class="elevation-2" style="background: white; padding: 10px 10px;">
                    <v-col cols="1" class="pe-2">
                        <div class="reportingTitle">ADVANCED</div>
                        <v-row>
                            <v-col>
                                <v-switch v-model="reportingAdvancedSearch" style="margin-left: 10px" hide-details
                                    true-value="true" false-value="false" inset></v-switch>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="3" lg="2" class="pe-2">
                        <div class="reportingTitle">REPORT NAME</div>
                        <v-row>
                            <v-col>
                                <v-select class="managementFormFields" hide-details v-model="runReportName"
                                    :items="availableReportNames" item-title="reportClass" variant="outlined"
                                    density="compact">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="4" lg="1" class="pe-2" v-if="reportingAdvancedSearch == 'true'">
                        <div class="reportingTitle">GPS</div>
                        <v-row>
                            <v-col>
                                <v-select class="managementFormFields" hide-details v-model="runGpsSource"
                                    :items="gpsSourceList" variant="outlined" density="compact">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="3" lg="2" class="pe-2" v-if="reportingAdvancedSearch == 'true'">
                        <div class="reportingTitle">STAFF ID</div>
                        <v-row>
                            <v-col>
                                <v-text-field class="managementFormFields" hide-details v-model="runStaffId"
                                    variant="outlined" density="compact">
                                </v-text-field>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="3" lg="2" class="pe-2">
                        <div class="reportingTitle">FROM</div>
                        <v-row>
                            <v-col>
                                <VueDatePicker v-model="runFrom" auto-apply :enable-time-picker="false" arrow-navigation
                                    text-input input-class-name="dp-custom-input-bottom" menu-class-name="dp-custom-menu"
                                    utc />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="3" lg="2" class="pe-2">
                        <div class="reportingTitle">TO</div>
                        <v-row>
                            <v-col>
                                <VueDatePicker v-model="runTo" auto-apply :enable-time-picker="false" arrow-navigation
                                    text-input input-class-name="dp-custom-input-bottom" menu-class-name="dp-custom-menu"
                                    utc />
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="3" lg="1" class="pe-2" v-if="reportingAdvancedSearch == 'true'">
                        <div class="reportingTitle">FORMAT</div>
                        <v-row>
                            <v-col>
                                <v-select class="managementFormFields" hide-details v-model="runFormat" :items="formatList"
                                    variant="outlined" density="compact">
                                </v-select>
                            </v-col>
                        </v-row>
                    </v-col>

                </v-row>
                <v-row no-gutters>
                    <v-spacer></v-spacer>
                    <v-btn :disabled="runReportName === null" @click="runReports" dark
                        class="reportBtn" style="
                      background: rgba(0, 0, 122, 0.2);
                      border: 2px solid #297286;
                    " variant="outlined">RUN</v-btn>
                </v-row>
            </div>
            <div style="padding: 10px 10px; background: rgb(224, 224, 224);">
                <v-row no-gutters>
                    <h1>Scheduled Reports</h1>

                </v-row>
                <v-row no-gutters class="managementTableInfo">
                    <strong>Double Click on Row to Edit</strong>
                    <v-spacer></v-spacer>
                    <span v-if="flag==true">*Multiple Distribution Emails Must Be Separated By a Comma</span>

                </v-row>
                <v-row no-gutters>
                    <div style="height: 300px; width: 100%">
                        <ag-grid-vue style="width: 100%; height: 100% !important; "
                            class="ag-theme-balham elevation-2 managementGrid" :columnDefs="columnDefs"
                            @grid-ready="onGridReady" :defaultColDef="defaultColDef" editType="fullRow"
                            :rowData="rowData" @cellEditingStarted="onCellEditingStarted" @cellEditingStopped="onCellEditingStopped"></ag-grid-vue>
                    </div>
                </v-row>
                <v-row no-gutters>
                    <v-btn class="reportBtn" @click="addDialog" dark style="
                      background: white;
                      border: 2px solid #297286;
                    " variant="outlined">add</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="reportBtn" @click="saveReports" dark style="
                      background: rgba(21, 102, 124, 0.2);
                      border: 2px solid #297286;
                    " variant="outlined">save</v-btn>
                    <v-btn class="reportBtn" @click="refreshPage" dark style="
                      background: rgba(128, 128, 128, 0.2);
                      border: 2px solid #297286;
                      float: right; 
                    " variant="outlined">clear</v-btn>
                </v-row>
            </div>
            <v-dialog v-model="dialogReporting" width="1200">
                <v-card style="text-align: left; background: rgb(240, 240, 240);" min-height="200">
                    <v-row no-gutters>
                        <h1 style="margin-left: 10px; color:#297286;">Add a Report</h1>
                    </v-row>
                    <v-row no-gutters style="background: white; padding: 10px 10px;">
                        <v-col cols="12" md="4" lg="3" class="pe-2">
                            <div class="reportingTitle">REPORT NAME</div>
                            <v-row>
                                <v-col>
                                    <v-select class="managementFormFields" hide-details v-model="addReportName"
                                        :items="availableReportNames" item-title="reportClass" return-object
                                        variant="outlined" density="compact">
                                    </v-select>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="3" lg="3" class="pe-2">
                            <div class="reportingTitle">Active</div>
                            <v-row>
                                <v-col>
                                    <v-checkbox v-model="addActive" style="margin-top: -5px;"></v-checkbox>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="3" lg="3" class="pe-2">
                            <div class="reportingTitle">Report Interval</div>
                            <v-row>
                                <v-col>
                                    <v-select variant="outlined" v-model="addReportInterval"
                                        :items="intervalList"></v-select>
                                </v-col>
                            </v-row>
                        </v-col>
                        <v-col cols="12" md="3" lg="3" class="pe-2">
                            <div class="reportingTitle">Distribution</div>
                            <v-row>
                                <v-col>
                                    <v-text-field variant="outlined" v-model="addDistribution"></v-text-field>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                    <v-row no-gutters>
                        <v-btn class="reportBtn" @click="addReport" dark style="
                      background: white;
                      border: 2px solid #297286;
                    " variant="outlined">add</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn class="reportBtn" @click="clearAdds" dark style="
                      background: rgba(128, 128, 128, 0.2);
                      border: 2px solid #297286;
                      float: right; 
                    " variant="outlined">clear</v-btn>
                    </v-row>

                </v-card>

            </v-dialog>
        </v-main>
    </v-layout>
</template>

<script>
import { AgGridVue } from "ag-grid-vue3";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { authTokenService } from "@/services/authTokenService.js";
import { commonService } from "@/services/common.service.js";
import { managementService } from "@/services/management.service.js";
import { STORE_CONSTANTS } from "@/common/store.constants";
import VueDatePicker from "@vuepic/vue-datepicker";


import Header from "@/components/Header.vue";


export default {
    name: "reporting",
    components: {
        Header,
        AgGridVue,
        VueDatePicker,
    },
    data: () => ({
        STORE_CONSTANTS,
        study: null,
        availableReportName: {},
        availableReportNames: [],
        columnDefs: [
            { field: 'reportClass',  minWidth: 100, maxWidth: 300 },
            { field: 'active', editable: true, cellDataType: 'boolean', minWidth: 100, maxWidth: 300 },
            {
                field: 'reportInterval', editable: true, cellDataType: 'string', cellEditor: 'agSelectCellEditor',
                cellEditorParams: {
                    values: ['DAY', 'WEEK'],
                    valueListGap: 0
                },
                minWidth: 100, maxWidth: 300
            },
            {
                field: 'distribution', editable: true, cellDataType: 'string', 
            },
        ],
        gridApi: null,
        columnApi: null,
        defaultColDef: {
            cellStyle: { textAlign: 'left' }
        },
        rowData: null,
        dialogReporting: false,
        addReportName: null,
        addActive: false,
        addReportInterval: null,
        addDistribution: null,
        gpsSourceList: ["PHONE", "LAPTOP"],
        formatList: ["CSV", "JSON"],
        runReportName: null,
        runGpsSource: null,
        intervalList: ['DAY', 'WEEK'],
        runStaffId: null,
        runFrom: null,
        runTo: null,
        runFormat: "CSV",
        reportingAdvancedSearch: false,
        rubBtnDisabled: true,
        flag: false
    }),
    mounted() {
        window.addEventListener("resize", this.onResize);
    },
    created() {
        this.study = this.$store.getters["study/getSelectedStudyId"];
        const me = this;
        commonService
            .getUIAndApiVersion()
            .then(function (response) {
                if (response && response.data) {
                    me.APIVersion = response.data.version;
                }
            })
            .catch(function (e) {
                console.log(e);
            });
        me.getReports();
    },
    updated() {
        this.onResize();
    },
    methods: {
        onGridReady(params) {
            const me = this;
            this.gridApi = params.api;
            this.gridApi.sizeColumnsToFit();
            this.gridColumnApi = params.columnApi;
            var scheduledReportsCriteria = {
                study: me.study
            }
            managementService
                .scheduledReports(scheduledReportsCriteria)
                .then(function (response) {
                    if (response && response.data) {
                        console.log("scheduledReports: ", response.data)
                        me.rowData = response.data
                    }
                })
                .catch(function (e) {
                    console.log(e);
                });
        },
        onResize(event) {
            this.gridApi.sizeColumnsToFit();
        },
        selectStudy(study) {
            this.study = study;
            this.$store.commit(
                this.STORE_CONSTANTS.STUDY.MUTATIONS.WITH_NAMESPACE
                    .SET_SELECTED_STUDY_ID,
                study
            );
            this.refreshPage()
        },
        getReports() {
            const me = this;
            managementService
                .getReports()
                .then(function (response) {
                    if (response && response.data) {
                        console.log('getReports response.data', response.data)
                        me.availableReportNames = response.data
                        me.availableReportName = response.data[1]
                    }
                })
                .catch(function (e) {
                    console.log(e);
                });
        },
        runReports() {
            const me = this;
            var criteria = {
                studyCode: me.study,
                reportClass: me.runReportName,
                sourceGPS: me.runGpsSource,
                responseFormat: me.runFormat,
                staffId: me.runStaffId,
                timeStart: me.runFrom,
                timeEnd: me.runTo,
            }
            managementService
                .runReports(criteria)
                .then(function (response) {
                    if (response && response.data) {
                        console.log('runReports response', response)
                        // me.desserts = response.data
                    }
                })
                .catch(function (e) {
                    console.log(e);
                });
        },
        scheduledReports() {
            const me = this;
            var criteria = {
                study: me.study
            }
            managementService
                .scheduledReports(criteria)
                .then(function (response) {
                    if (response && response.data) {
                        console.log('scheduledReports response.data', response.data)
                        me.rowData = response.data
                    }
                })
                .catch(function (e) {
                    console.log(e);
                });
        },
        saveReports() {
            console.log('this.rowData: ', this.rowData)
            const me = this;
            console.log('me.gridApi: ', me.gridApi)
            me.gridApi.stopEditing();
            const criteria = {
                study: me.study,
                data: me.rowData
            }
            managementService
                .saveReports(criteria)
                .catch(function (e) {
                    console.log(e);
                });
        },
        refreshPage() {
            // location.reload();
            const me = this;
            var criteria = {
                study: me.study
            }
            me.scheduledReports(criteria);
        },
        addDialog() {
            this.dialogReporting = true;
        },
        addReport() {
            const me = this;
            this.dialogReporting = false;
            let repClass = '';
            if (me.addReportName) {
                repClass = me.addReportName.reportClass
            }
            let reportObject = {
                reportClass: repClass,
                active: me.addActive,
                reportInterval: me.addReportInterval,
                distribution: me.addDistribution
            }
            console.log('reportObject: ', reportObject)
            me.rowData.push(reportObject)
        },
        clearAdds() {
            this.addReportName = null;
            this.addActive = false;
            this.addReportInterval = null;
            this.addDistribution = null;
        },
        onCellEditingStarted(params) {
            // Handle the cell editing started event
            // this.editingCell = params.node;
            this.flag = true
        },
        onCellEditingStopped(params) {
        // Handle the cell editing stopped event
        // this.editingCell = null; // Reset the editingCell when editing is stopped
        this.flag = false
    },
    }
}
</script>

<style scoped>
.reportBtn {
    margin: 5px 5px;
}

.reportingTitle {
    text-align: left;
    color: rgb(41, 114, 134);
    font-size: 16px;
}

.ag-theme-balham {
    --ag-font-size: 16px;
}
</style>